import React, { useEffect } from 'react';
import { Grid, TextField, Box } from '@mui/material';
import { useFormik } from "formik";
import * as yup from "yup";
import styles from './Lab.module.scss'
import { CMButton } from '../Button/Button';
import { buttonStyle } from '../Helpers/InlineStyles';
import { CMLabel } from '../Form/FormLabels';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import 'react-toastify/dist/ReactToastify.css';
import { CMAutoComplete } from '../AutoComplete/AutoComplete';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { MedicineAllFields, MedicineDiagnosisUpdate, MedicineDropdown, MedicineNameDropdown, editMedicine } from '../../../Pages/Medicines/MedicinesServices';
import { numberRegex, wordToWordSpaceRegex } from '../Helpers/Validations';
import { useParams } from 'react-router';


function MedicineModel(props: any) {
    const ModelBodyComponent = props.modelCmpnt;
    const [medicinedropdown, setMedicedropdown] = React.useState([]);
    const [medicineOptions, setMedicineOption] = React.useState('');
    const [selectedOption, setSelectedOption] = React.useState([]);
    const [medicinename,setMedicinename]=React.useState<any>() 
    const [closingBalance, setClosingBalance] = React.useState('');
    const [fieldData, setFieldData] = React.useState([]);
    const [updateConsumption, setUpdateConsumption] = React.useState<any>();
    const currentDate = dayjs().format('YYYY-MM-DD');
    const { id } = useParams();
    
    useEffect(() => {
        MedicineNameDropdown().then((res: any) => {
            setSelectedOption(res);
        });
        MedicineAllFields().then((res: any) => {
            setFieldData(res);
        })
        MedicineDropdown().then((res: any) => {
            setMedicedropdown(res);
            setMedicineOption(res);
        });
    }, []);
   
    const handleDropdownChange = (fields: any, e: any) => {
        const selectedMedicine: any = selectedOption.find((item: any) => item.medicine_name === e.label);

        if (selectedMedicine) {
            formik.setFieldValue('medicine_name', e.label);
            formik.setFieldValue('opening_stock', selectedMedicine.closing_balance || '');
            setUpdateConsumption(selectedMedicine)
        }
    }

    const handleDateChange = (fields: any, e: any) => {
        const date = dayjs(e['$d']).format('YYYY-MM-DD')
        formik.setFieldValue(fields, date)
    }
    const updateclosingBalance = (totalstock: any, consumption: any) => {
        const num5: any = parseFloat(totalstock);
        const num6: any = parseFloat(consumption);
        if (!isNaN(num6) && !isNaN(num5)) {
            const result: any = (num5 - num6);
            setClosingBalance(result.toString());
        } else {
            setClosingBalance('');
        }
    }

const handleMedicineChange = (fields: any, e: any) => {
    // const medicineIssued = parseFloat(e.target.value);
    // const initialConsumption:any = Number(updateConsumption.consumption);
    // const updatedConsumption:any = Number(initialConsumption) + medicineIssued;
    // const updatedClosingBalance = updateConsumption.total_stock - Number(updatedConsumption);
    // console.log(updateConsumption.consumption,"updateConsumption.consumption")
    if(e.target.value > formik.values?.opening_stock){
        formik.setFieldError(fields, 'Value must be less than opening stock');
    }else{
        formik.setFieldValue(fields, e.target.value);
        setMedicinename( e.target.value)
    }
}

    const formik: any = useFormik({
        initialValues: {
            id: props?.rowData?.id? props?.rowData?.id : "",
            medicine_name: props?.rowData?.medicine_name ? props?.rowData?.medicine_name : medicineOptions[0],
            opening_stock: props?.rowData?.opening_stock ? props?.rowData?.opening_stock : "",
            medicine_issued: props?.rowData?.medicine_issued ? props?.rowData?.medicine_issued : "",
            date: props?.rowData?.date ? props?.rowData?.date : currentDate,
        },
        validationSchema: yup.object({
            medicine_name: yup.string().required("Medicine Name is required"),
            date: yup.string().required("Date is required"),
            opening_stock: yup.string().ensure().required("Opening Stock is required!").matches(numberRegex, { message: "Please enter only numbers!" }),
            medicine_issued: yup.string().ensure().required("Medicine Issued is required").matches(numberRegex, { message: "Please enter only numbers!" }),
        }),
        onSubmit: (values: any) => {
          const initialConsumption:any = Number(updateConsumption.consumption);
          const updatedConsumption11:any = Number(initialConsumption) + Number(medicinename);
          const updatedClosingBalance11 = updateConsumption.total_stock - Number(updatedConsumption11);
            values.consumption=updatedConsumption11
            values.closing_balance=updatedClosingBalance11
            console.log(initialConsumption,updatedConsumption11,values.consumption,updatedClosingBalance11,'juk')
                const medicineUpdate:any = {
        "id": updateConsumption.id,
        "medicine_name": updateConsumption.medicine_name,
        "opening_stock": updateConsumption.opening_stock,
        "date": updateConsumption.date,
        "invoice_number": updateConsumption.invoice_number,
        "invoice_date": updateConsumption.invoice_date,
        "total_stock": updateConsumption.total_stock,
        "stock_purchased": updateConsumption.stock_purchased,
        "consumption": updatedConsumption11,
        "closing_balance": updatedClosingBalance11
    }
    setUpdateConsumption(medicineUpdate);
    if (medicineUpdate) {
        MedicineDiagnosisUpdate(medicineUpdate, updateConsumption.id).then((res: any) => {

        })
    }

            if (props?.rowData) {
                let totalvalues = { ...values };
                // totalvalues.date = dayjs(totalvalues.date).format("DD-MM-YYYY");
                props.edit(totalvalues);
            } else {
                let totalvalues = { ...values };
                // totalvalues.date = dayjs(totalvalues.date).format("DD-MM-YYYY");
                props.onAddRow(totalvalues);
            }
            formik.resetForm();
            props?.onHide();
            // localStorage.removeItem('lab');
        },
    });

    return (
        <>
            {props?.show &&
                <Modal isOpen={props?.show} onHide={props?.onHide} >
                    <ModalHeader toggle={props.onHide}><h5><b>{props.header}</b></h5></ModalHeader>
                    <ModalBody>
                        <form onSubmit={formik.handleSubmit}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <CMLabel>Medicine Name</CMLabel>
                                    <CMAutoComplete
                                        options={medicinedropdown}
                                        disabled={false}
                                        placeholder="Enter Medicine name"
                                        name="medicine_name"
                                        value={formik?.values?.medicine_name
                                            //  || (medicinedropdown.length > 0 ? medicinedropdown[0] : '')
                                        }
                                        onChange={(e: any) => handleDropdownChange("medicine_name", e)}
                                        errors={formik.touched.medicine_name && Boolean(formik.errors.medicine_name)}
                                        helperText={formik.touched.medicine_name && formik.errors.medicine_name} />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <CMLabel>Date</CMLabel>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            slotProps={{ textField: { fullWidth: true, size: 'small', name: 'date' } }}
                                            format="YYYY-MM-DD"
                                            value={dayjs(formik?.values?.date)}
                                            onChange={(val) => handleDateChange('date', val)} />
                                    </LocalizationProvider>
                                    {formik.touched.date && formik.errors.date && (
                                        <div className={styles.laberrortext + " text-danger"}>{formik.errors.date}</div>)
                                    }
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <CMLabel>Opening Stock</CMLabel>
                                    <TextField
                                        placeholder='Enter opening stock '
                                        size="small"
                                        name="opening_stock"
                                        fullWidth
                                        disabled
                                        // onChange={(e) => handleChange("opening_stock", e)}
                                        value={formik.values?.opening_stock}
                                    />
                                    {formik.touched.opening_stock && formik.errors.opening_stock && (
                                        <div className={styles.laberrortext + " text-danger"}>{formik.errors.opening_stock}</div>)
                                    }
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <CMLabel>Medicine Issued</CMLabel>
                                    <TextField
                                        placeholder='Enter Medicine Issued'
                                        size="small"
                                        name="medicine_issued"
                                        fullWidth
                                        onChange={(e) => handleMedicineChange("medicine_issued", e)}
                                        value={formik.values?.medicine_issued}
                                    />
                                    {formik.touched.medicine_issued && formik.errors.medicine_issued && (
                                        <div className={styles.laberrortext + " text-danger"}>{formik.errors.medicine_issued}</div>)
                                    }
                                </Grid>
                            </Grid>
                            <Box component='div'
                                sx={buttonStyle}>
                                <Box component='span'>
                                    <CMButton variant="contained" value="Submit" type="submit" color="primary" />
                                </Box>
                            </Box>
                        </form>
                    </ModalBody>
                </Modal>
            }
        </>
    );
}

export default MedicineModel;
